import formatNumbers from '../../../../helpers/formatNumbers';
import get from '../../../../helpers/get';

function makeTermFinanceButtons(options, selectedValue) {
    let htmlString = "";
    options.forEach((val, i) => {
        if (val !== selectedValue) {
            htmlString += `
            <input type="radio" name="term-finance-group" value="${val}" id="tf${i}" />
            <label class="radio-term" for="tf${i}">${val}</label>
            `;
        } else {
            htmlString += `
            <input type="radio" name="term-finance-group" value="${val}" id="tf${i}" checked="checked" />
            <label class="radio-term" for="tf${i}">${val}</label>
            `;
        }
    });
    return htmlString;
}

function makeTermLeaseButtons(options, selectedValue) {
    let htmlString = "";
    options.forEach((val, i) => {
        if (val !== selectedValue) {
            htmlString += `
            <input type="radio" name="term-lease-group" value="${val}" id="tl${i}" />
            <label class="radio-term" for="tl${i}">${val}</label>
            `;
        } else {
            htmlString += `
            <input type="radio" name="term-lease-group" value="${val}" id="tl${i}" checked="checked" />
            <label class="radio-term" for="tl${i}">${val}</label>
            `;
        }
    });
    return htmlString;
}

function makeMpyButtons(options, selectedValue) {
    let htmlString = "";
    options.forEach((val, i) => {
        let valString = (val / 1000) + 'K';
        if (val !== selectedValue) {
            htmlString += `
            <input type="radio" name="miles-group" value="${val}" id="m${i}" />
            <label class="radio-term" for="m${i}">${valString}</label>
            `;
        } else {
            htmlString += `
            <input type="radio" name="miles-group" value="${val}" id="m${i}" checked="checked" />
            <label class="radio-term" for="m${i}">${valString}</label>
            `;
        }
    });
    return htmlString;
}

function calculatedPaymentText(dealData, paymentOption, isItemizedPriceOpen, firstRender, entireDeal) {
    const headerData = formatHeaderData(dealData, paymentOption, isItemizedPriceOpen, firstRender, entireDeal);

    let header =
        `<span class="payment-span">
            <h2 class="header-your-payment">Your ${headerData.paymentText} payment</h2>
            <h2 class="header-dollar-amount">$${headerData.headerText}</h2>
        </span>
        `;

    let dealSpecifics = `
        <div class="deal-specifics">
            ${ headerData.downPayment}
            ${ headerData.term}
            ${ headerData.APR}
            ${ headerData.rebates}
            ${ headerData.miles}
        </div>
    `;

    let footer = `<span>Incl. taxes and fees${headerData.footerText}</span>`;

    let itemizedButton = `
        <div class="itemized-price-button-container">
            <a class="itemized-price--button">${headerData.footerButton}</a>
            <svg viewBox="0 0 16 16" width="13" height="12" class="itemized-price--chevron" ${headerData.chevronPosition}>
                <polygon points="16,4.378 15.25,3.625 8,10.877 0.752,3.625 0,4.378 8,12.375"></polygon>
            </svg>
        </div>`;

    return [
        header,
        dealSpecifics + footer,
        itemizedButton
    ];
}

function formatHeaderData(dealData, paymentOption, isItemizedPriceOpen, firstRender, entireDeal) {
    const headerData = {};
    const deal = {};
    const cash = paymentOption === 'cash';
    let totalRebates = 0;
    const APRSlash = firstRender && !entireDeal ? '' : '|';
    if (entireDeal) {
        const selectedOffer = dealData[paymentOption].selected_offer;
        const topDeal = dealData[paymentOption].offers[selectedOffer];

        deal.rebates = topDeal.rebates;
        deal.lender = topDeal.lender;
        deal.miles = dealData[paymentOption].miles;
        deal.downPayment = dealData[paymentOption].down_payment;
        deal.term = dealData[paymentOption].term;
        deal.interestRateDisplay = topDeal.interest_rate_display;
        deal.payment = topDeal.payment;
        deal.amountFinanced = topDeal.amount_financed;
    } else {
        deal.rebates = dealData.loan.rebates;
        deal.lender = dealData.loan.lender;
        deal.interestRateDisplay = dealData.loan.interest_rate_display;
        deal.payment = dealData.loan.payment;
        deal.amountFinanced = dealData.loan.amount_financed;
    }

    deal.rebates.forEach((rebate) => {
        totalRebates += rebate.value;
    });

    headerData.footerText = paymentOption !== 'cash' ? `, on approved credit, from ${deal.lender}` : '';
    headerData.footerButton = isItemizedPriceOpen ? 'Hide itemized price' : 'View itemized price';
    headerData.chevronPosition = isItemizedPriceOpen ? 'style="transform: rotate(180deg)"' : '';
    headerData.milesAmount = (deal.miles / 1000);
    headerData.downPayment = paymentOption !== 'cash' && deal.downPayment >= 0 ? `<p>$${formatNumbers(deal.downPayment, 'money')} down</p> |` : '';
    headerData.term = paymentOption !== 'cash' && deal.term ? `<p>${deal.term} mos</p>` : '';
    headerData.APR = paymentOption === 'loan' ? `${APRSlash} <p>${deal.interestRateDisplay} APR</p>` : '';
    headerData.miles = paymentOption === 'lease' ? `| <p>${headerData.milesAmount}K </p>` : '';
    headerData.rebates = deal.rebates[0] ? `${paymentOption !== 'cash' && totalRebates ? '| ' : ''}<p>$${formatNumbers(totalRebates, 'money')} rebate</p>` : '';

    if (!cash) {
        headerData.dollarAmount = formatNumbers(deal.payment, 'money');
        headerData.headerText = `${headerData.dollarAmount}<span class="month-text">/mo</span>`;
        headerData.paymentText = `monthly`;
    } else {
        headerData.dollarAmount = formatNumbers(deal.amountFinanced, 'money');
        headerData.headerText = `${headerData.dollarAmount}`;
        headerData.paymentText = `total`;
    }

    return headerData;
}

function rebatesContainer(rebates) {
    let rebatesString = '';
    if (rebates && rebates[0]) {
        rebates.map((rebate) => {
            let title = rebate.name.toLowerCase().indexOf("national") !== -1 ? 'Automatically applied' : rebate.name;

            rebatesString += `
            <div class="rebate-tab__container">
            <div class="rebate-tab__left-container">
            <span class="rebate-tab__value">$${formatNumbers(rebate.value, 'money')}</span>
            <span class="rebate-tab__name">${title}</span>
            </div>
            </div>
            `;
        });
    } else {
        rebatesString = `
            <p class="rebates-error">We didn’t find any available rebates. The seller will reach out to you if there are rebates that apply once you submit.</p>
        `;
    }
    const rebatesDisclaimer =
        `<div class="payment-details__legal details__rebates-disclaimer">
            <h3 class="payment-details__legal-rebates-copy">
                We use our best efforts to see that all incentives are accurate when posted in Online Shopper. However, errors can occur, vehicles entitled to incentives may be sold, or incentives may expire. All incentives must be confirmed with an authorized salesperson at dealership at time of purchase. Actual taxes are based on your address, and will be calculated at time of purchase.
            </h3>
        </div>`;
    const rebatesHeader =
        `<h3 class="rebates__body-header">
            Your rebates & incentives
        </h3>`;

    return rebatesHeader + rebatesString + rebatesDisclaimer;
}

function makeItemizedDisclaimerText(paymentOption, lender, creditEstimate) {
    let itemizedDisclaimerText;

    switch (paymentOption) {
        case 'cash':
            itemizedDisclaimerText = 'Registration & Fees included -  DMV fee, documentation fee, tire fee and electronic filing fee. Taxes are estimates. The dealership will help determine accurate taxes prior to delivery.';
            break;
        case 'lease':
            itemizedDisclaimerText = `Registration & Fees included -  DMV fee, documentation fee, tire fee and electronic filing fee. Rate subject to approval of credit with a credit score of ${creditEstimate} or higher. Financing arranged through ${lender}. Monthly payment includes all taxes and fees, and any manufacturer rebates. Taxes are estimates. The dealership will help determine accurate taxes prior to delivery.`;
            break;
        default:
            itemizedDisclaimerText = `Registration & Fees included -  DMV fee, documentation fee, tire fee and electronic filing fee. Rate subject to approval of credit with a credit score of ${creditEstimate}  or higher. Financing arranged through ${lender}. Monthly payment includes all taxes and fees, and any manufacturer rebates. Taxes are estimates. The dealership will help determine accurate taxes prior to delivery.`;
            break;
    }

    return itemizedDisclaimerText;
}

function makeDetailsDisclaimerText(paymentOption, selectedOptionInfo) {
    let detailsDisclaimerText;
    const currentOffer = selectedOptionInfo.offers[selectedOptionInfo.selected_offer];

    switch (paymentOption) {
        case 'cash': {
            detailsDisclaimerText = 'This quote is an estimate based on information you provided and other information available to us as of the date of this quote, and is not an offer or sales contract. The final terms of your purchase finance or lease transaction are determined at the time you purchase or lease the vehicle and are subject to verification of all taxes and fees, your qualification for financing, final determination of the value of your trade-in vehicle (if applicable), and your signing the final contract (including applicable financing documents). Purchase or lease of this vehicle is subject to its availability.';
            break;
        }
        case 'lease': {
            const leaseLender = currentOffer.lender;
            const leaseMonths = selectedOptionInfo.term;
            const msrp = formatNumbers(selectedOptionInfo.price, 'money');
            const totalMonthlyPayment = formatNumbers(currentOffer.payment, 'money');
            const capitalizedCostReduction = formatNumbers(selectedOptionInfo.down_payment, 'money');
            let acquisitionFee = currentOffer.fees.find( fee => fee.name = "Acquisition Fee" ).value;
            acquisitionFee = formatNumbers(acquisitionFee, 'money');
            const firstMonthsLeasePayment = formatNumbers(currentOffer.payment, 'money');
            const purchaseOptionAmount = formatNumbers(currentOffer.residual, 'money');
            detailsDisclaimerText = `Available only to qualified customers through ${leaseLender} at participating authorized dealers. Not everyone will qualify. Advertised ${leaseMonths} month lease rate based on MSRP of $${msrp}. Dealer contribution may vary and could affect your actual lease payment. Includes Destination charge and optional packages or equipment. Includes title, taxes, registration, license fees, insurance, dealer prep and additional options. Total monthly payments equal $${totalMonthlyPayment}. Cash due at signing includes $${capitalizedCostReduction} capitalized cost reduction, $${acquisitionFee} acquisition fee, and first month’s lease payment of $${firstMonthsLeasePayment}. No security deposit required. At lease end, lessee pays for any amounts due under the lease, any official fees and taxes related to the scheduled termination, excess wear and use. Purchase option at lease end for $${purchaseOptionAmount} plus taxes in example shown. Subject to credit approval. See dealer for complete details.`;
            break;
        }
        default: {
            const apr = currentOffer.interest_rate_display;
            const financingMonths = selectedOptionInfo.term;
            const financingCost = formatNumbers(currentOffer.per_k, 'money');
            const financeLender = currentOffer.lender;
            detailsDisclaimerText = `For qualified customers only. ${apr} APR financing for ${financingMonths} months at $${financingCost} per month, per $1,000 financed. Excludes leases and balloon contracts. Includes title, taxes, registration, license fees, insurance, dealer prep and additional options. Available only at participating authorized dealers through ${financeLender}. Specific vehicles are subject to availability and may have to be ordered. Subject to credit approval by lender. Not everyone will qualify. See your authorized dealer for complete details on this and other finance offers.`;
            break;
        }
    }

    let detailsDisclaimerParagraph = `${detailsDisclaimerText}`;
    return detailsDisclaimerParagraph;
}

export default {
    makeTermFinanceButtons,
    makeTermLeaseButtons,
    makeMpyButtons,
    calculatedPaymentText,
    rebatesContainer,
    makeItemizedDisclaimerText,
    makeDetailsDisclaimerText
};
